export const RandomId = () => {
  const generateRandomId = (prefix = '') => {
    return prefix + Math.random().toString(36).substring(2, 9);
  };

  return {
    generateRandomId,
  };
};
